<template>
    <div>
        <app-nav></app-nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-2"></div>
                 <div class="col-md-10">
                    <h5 class="text-left">Modifier !</h5>
                        <form v-on:submit.prevent class="titulaire-form">
                            <div class="form-group row">
                                <label for="nom" class="col-sm-2 control-label"> Nom</label>
                                <div class="col-sm-5">
                                    <input autofocus required :value="titulaireById.nom" placeholder="Nom" autocomplete="off" class="form-control"  v-on:keyup.stop="updateNom($event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="prenom" class="col-sm-2 control-label">Prénom</label>
                                <div class="col-sm-5">
                                    <input :value="titulaireById.prenom" class="form-control" placeholder="Prénom" autocomplete="off" type="text" v-on:keyup.stop="updatePrenom($event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="sel" class="col-sm-2 control-label">SEL</label>
                                <div class="col-sm-5">
                                    <input  name="sel" type="text" class="form-control" placeholder="nom de la SEL"  :value="titulaireById.sel" v-on:keyup.stop="updateSel($event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="numsel" class="col-sm-2 control-label"> N° de SEL</label>
                                <div class="col-sm-5">
                                    <input name="numsel" type="text" class="form-control" placeholder="numéro de la SEL" :value="titulaireById.numsel" v-on:keyup.stop="updateNumsel($event.target.value)" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="ordre" class="col-sm-2 control-label"> Num. conseil de l'ordre</label>
                                <div class="col-sm-5">
                                    <input name="ordre" type="text" class="form-control" placeholder="Num. conseil de l'ordre" :value="titulaireById.ordre" v-on:keyup.stop="updateOrdre($event.target.value)"/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="adeli" class="col-sm-2 control-label"> Num. adeli</label>
                                <div class="col-sm-5">
                                    <input name="adeli" type="text" class="form-control" placeholder="Num. adeli" :value="titulaireById.adeli" v-on:keyup.stop="updateAdeli($event.target.value)" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="rpps" class="col-sm-2 control-label"> RPPS</label>
                                <div class="col-sm-5">
                                    <input name="rpps" type="text" class="form-control" placeholder="RPPS" :value="titulaireById.rpps" v-on:keyup.stop="updateRpps($event.target.value)"/>
                                </div>
                            </div>
                             <div class="form-group row">
                                <label for="retraite" class="col-sm-2 control-label">Retraité ?</label>
                                <div class="col-sm-5">
                                    <select class="form-control" v-on:change="sourceRetraiteSelect">
                                       <option  :value="titulaireById.retraite">{{titulaireById.retraite?"Oui":"Non"}}</option>
                                       <option  >{{!titulaireById.retraite?"Oui":"Non"}}</option>
                                      
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                            <button class="btn btn-primary" type="submit" @click="updateTitulaire">Valider</button>
                            </div>
                        </form>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../router'
import AppNav from './AppNav'
import {isNull} from 'lodash'
import {
  UPDATE_TITULAIRE,
  TITULAIRE_BY_ID_QUERY 
} from '../constants/graphql'

  export default {
    name: 'titulaires-edit',
    components: {
      AppNav,
    },
    data() {
      return {
        titulaireById: {},
        nom:  "",
        prenom: "",
        sel: "",
        numsel: "",
        adeli: "",
        ordre: "",
        rpps: "",
        retraite: null
      }
    },
    apollo: {
      titulaireById: {
            query: TITULAIRE_BY_ID_QUERY,
            variables() {
                var id = parseInt(this.$route.params.id,10)
                return{
                    id
                }
            }
        }
    },
    methods: {
        sourceRetraiteSelect(e){
            //TODO: I probably miss something in the dropbox
            this.retraite = (e.target.value === 'Oui' || e.target.value ===  true )?true:false;
        },
        updateNom(value) {         
            this.nom = value
        },
        updatePrenom(value) {
            this.prenom = value
        },
        updateSel(value) {
            this.sel = value
        },
        updateNumsel(value) {
            this.numsel = value
        },
        updateOrdre(value) {
            this.ordre = value
        },
        updateAdeli(value) {
            this.adeli = value
        },
        updateRpps(value) {
            this.rpps = value
        },
        updateTitulaire() {
            const nom    = (this.nom == "") ? this.titulaireById.nom : this.nom;
            const prenom = (this.prenom == "") ? this.titulaireById.prenom : this.prenom;
            const sel    = (this.sel == "") ? this.titulaireById.sel : this.sel;
            const numsel = (this.numsel == "") ? this.titulaireById.numsel : this.numsel;
            const adeli  = (this.adeli == "") ? this.titulaireById.adeli : this.adeli;
            const ordre  = (this.ordre == "")? this.titulaireById.ordre : this.ordre;
            const rpps  = (this.rpps == "")? this.titulaireById.rpps : this.rpps;
            const retraite = (isNull(this.retraite))? this.titulaireById.retraite :this.retraite;
            this.$apollo.mutate({
            mutation: UPDATE_TITULAIRE,
            variables: {
                id: this.titulaireById.id,
                nom: nom,
                prenom: prenom,
                sel: sel,
                numsel: numsel,
                adeli: adeli,
                ordre: ordre,
                rpps: rpps,
                retraite: retraite
            }
            }).then((data) => {
                router.push({name: 'Titulaire' , params: { id: this.titulaireById.id}})
            }).catch((error) => {
            // Error
            console.error(error)
            })
       }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

body {
    padding-top: 3.5rem;   
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}


/*
 * Sidebar
 */

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}


/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}


/*
 * Dashboard
 */


/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}


</style>



// WEBPACK FOOTER //
// titulairesEdit.vue?2211c226